import React, { useState } from 'react';
import {
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Tooltip,
} from '@fluentui/react-components';
import { Settings24Regular, SignOut24Regular, BookInformation24Regular } from '@fluentui/react-icons';
import './header.css';
import { useAuth } from 'react-oidc-context';
import { PreferencesDialog } from '../PreferencesDialog';
import logo192 from '../../assets/logo192.png';

export interface HeaderProps {
  onShowTutorial?: () => void;
  isWebSocketConnected?: boolean;
  hostVersion?: string;
}

export function Header({ onShowTutorial, isWebSocketConnected, hostVersion }: HeaderProps) {
    const auth = useAuth();
    const [preferencesOpen, setPreferencesOpen] = useState(false);
    
    function logout(): void {
        auth.signoutSilent({
            post_logout_redirect_uri: '/login'
        });
    }

    const handlePreferencesClick = () => {
        setPreferencesOpen(true);
    };

    return (
        <div className="header" data-testid="app-header">
            <img src={logo192} height="30px" alt="Logo" />
            <ul>
                <li style={{ justifyContent: 'start', marginLeft: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <Tooltip 
                        content={isWebSocketConnected ? 'WebSocket Connected' : 'WebSocket Disconnected'} 
                        relationship="description"
                    >
                        <span style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: isWebSocketConnected ? '#4CAF50' : '#F44336',
                            display: 'inline-block',
                            boxShadow: isWebSocketConnected ? '0 0 6px rgba(76, 175, 80, 0.8)' : '0 0 6px rgba(244, 67, 54, 0.8)',
                            cursor: 'help'
                        }}></span>
                    </Tooltip>
                    {hostVersion && (
                        <span style={{ fontSize: '0.85rem', color: '#666', whiteSpace: 'nowrap' }}>
                            v{hostVersion}
                        </span>
                    )}
                </li>
                <li>
                    <Menu>
                        <MenuTrigger disableButtonEnhancement>
                            <Avatar 
                                className='avatar' 
                                name={auth.user?.profile.name} 
                                color="royal-blue" 
                                size={40} 
                            />
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem icon={<Settings24Regular />} onClick={handlePreferencesClick}>
                                    Preferences
                                </MenuItem>
                                {onShowTutorial && (
                                    <MenuItem icon={<BookInformation24Regular />} onClick={onShowTutorial}>
                                        Show Tutorial
                                    </MenuItem>
                                )}
                                <MenuItem icon={<SignOut24Regular />} onClick={logout}>
                                    Sign Out
                                </MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </li>
            </ul>
            <PreferencesDialog 
                open={preferencesOpen} 
                onOpenChange={setPreferencesOpen}
            />
        </div>
    );
};